var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5898 6.21484C13.8359 5.96875 13.8359 5.55859 13.5898 5.28516L8.99609 0.691406C8.55859 0.28125 7.875 0.582031 7.875 1.15625V3.78125H4.15625C3.77344 3.78125 3.5 4.08203 3.5 4.4375V7.0625C3.5 7.44531 3.77344 7.71875 4.15625 7.71875H7.875V10.3438C7.875 10.9453 8.58594 11.2188 8.99609 10.8086L13.5898 6.21484ZM5.25 10.6719V9.57812C5.25 9.41406 5.08594 9.25 4.92188 9.25H2.625C2.13281 9.25 1.75 8.86719 1.75 8.375V3.125C1.75 2.66016 2.13281 2.25 2.625 2.25H4.92188C5.08594 2.25 5.25 2.11328 5.25 1.92188V0.828125C5.25 0.664062 5.08594 0.5 4.92188 0.5H2.625C1.17578 0.5 0 1.67578 0 3.125V8.375C0 9.82422 1.17578 11 2.625 11H4.92188C5.08594 11 5.25 10.8633 5.25 10.6719Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4a39c3f4f0ee3c227f9966822c6ead3c.svg";
export { ForwardRef as ReactComponent };